import { Transition } from '@headlessui/react';
import { message, Spin } from 'antd';
import useSelection from 'antd/lib/table/hooks/useSelection';
import { getAnalytics, logEvent } from 'firebase/analytics';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from '../../../../navigation';
import { menuItemsApi } from '../../../../api/menuItems';
import { setFeaturedProducts } from '../../../../features/restaurant/restaurant';
import { TTMenuItem } from '../../../../interfaces/menuItem';
import { RootState } from '../../../../rootReducer';
import { LoadingIcon } from '../../../components/Spinner';
import TrackingContext from '../../../Providers/TrackingContext';
import { useAppDispatch } from '../../../../store';

type Props = {
  merchant_id: number;
};

export function FeaturedProducts({ merchant_id }: Props) {
  const [fetching, setFetching] = useState(false);
  const featuredProducts = useSelector<RootState, TTMenuItem[]>(
    state => state.restaurant.featured_products,
  );
  const { trackFBEvent, trackGAEvent } = useContext(TrackingContext);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const fetchProducts = async () => {
    try {
      setFetching(true);
      const response = await menuItemsApi.getFeaturedItems(merchant_id);
      dispatch(setFeaturedProducts(response.data));
      setFetching(false);
    } catch (e) {
      setFetching(false);
      message.error(e?.response?.data?.detail);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);
  return (
    <>
      <div className="my-4 ">
        <div className="flex flex-col  px-4 mt-4  ">
          <Spin spinning={fetching} indicator={LoadingIcon}>
            {featuredProducts?.length !== 0 && (
              <div
                className="overflow-x-auto rounded-md border-4 border-dashed border-tertiary-container px-4 bg-tertiary"
                id={'featued_product_'}
              >
                <div className="flex flex-row text-tertiary-container font-semibold px-2 text-lg  overflow-x-auto items-center rounded-md py-2">
                  Featured Products
                </div>
                <div className="flex flex-row overflow-x-auto space-x-2 my-2 pb-4">
                  {featuredProducts?.map((p, i) => {
                    return (
                      <Transition
                        appear
                        key={p?.id?.toString()}
                        show={true}
                        as={Fragment}
                        enter="transform transition ease-in-out duration-500 sm:duration-700"
                        enterFrom="translate-y-full"
                        enterTo="translate-y-0"
                        leave="transform transition ease-in-out duration-500 sm:duration-700"
                        leaveFrom="translate-y-0"
                        leaveTo="translate-y-full"
                      >
                        <div
                          key={p?.id?.toString()}
                          onClick={() => {
                            logEvent(getAnalytics(), 'menu_item_clicked', {
                              menu_item_id: p.id,
                              menu_item_name: p.name,
                              is_featured: true,
                              click_location: 'featured_banner',
                            });
                            trackGAEvent(
                              'select_item',
                              {
                                items: [
                                  {
                                    item_id: `prod_${p.id}`,
                                    item_name: p.name,
                                    affiliation: 'SNAPnTAP',
                                    index: i,
                                    item_category: p.category?.name,
                                    item_list_id: 'featured_products',
                                    item_list_name: 'Featured Products',
                                    price: p.price / 100.0,
                                  },
                                ],
                              },
                              [merchant_id],
                            );
                            trackFBEvent(
                              'FeaturedProductClick',
                              {
                                content_ids: [`prod_${p.id}`],
                                content_type: 'product',
                                content_name: [p.name],
                              },
                              true,
                              [merchant_id],
                            );
                            navigate(
                              `/feed/restaurants/${merchant_id}/menus/${p?.menu_id}/items/${p?.id}`,
                            );
                          }}
                          className="bg-tertiary-container rounded-lg shadow-md cursor-pointer"
                        >
                          <div
                            className={`relative ${'w-40 md:w-40 lg:w-40 2xl:w-44'}`}
                          >
                            <div className="group block border-b border-white w-full  aspect-w-14 aspect-h-14 rounded-t-lg bg-gray-100 overflow-hidden">
                              <img
                                src={p?.image_url}
                                alt=""
                                className="object-cover pointer-events-none group-hover:opacity-75"
                              />
                            </div>
                            <div className="m-2 py-2 block text-md font-semibold text-on-tertiary-container pointer-events-none">
                              <p className="line-clamp-2 ">{p?.name}</p>
                            </div>
                            {/* <p className="block mx-2 text-sm text-on-tertiary-container pointer-events-none truncate-4-lines">
                              {p?.description ?? ''}
                            </p> */}
                          </div>
                        </div>
                      </Transition>
                    );
                  })}
                </div>
              </div>
            )}
          </Spin>
        </div>
      </div>
    </>
  );
}
